import * as angular from 'angular';

import { ReadType, WidgetValuesReadConfiguration, IBindable } from '../../models/';
import { Helper } from '../../common/';
import { WidgetWithErrors, IdataWidget, IMaximizable } from '../../widgets';
import { IwidgetIntervalHelperService } from '../../services';
import { ChartIdentifierWidgetConfiguration } from './chartByIdentifier.configuration';
import { chartByIdentifierWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class ChartByIdentifierWidget extends WidgetWithErrors implements IdataWidget, IMaximizable {
    baseType = definition.baseType;
    col = 0;
    configuration: ChartIdentifierWidgetConfiguration;
    exportToCsv: () => angular.IPromise<any>;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isDisabledMaximized = false;
    isExportable = true;
    isMaximizable = true;
    isMaximized = false;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(
        $translate: angular.translate.ITranslateService,
        private _$q: angular.IQService,
        intervalHelper: IwidgetIntervalHelperService,
    ) {
        super(intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new ChartIdentifierWidgetConfiguration($translate);
    }

    getSeriesGuids(): string[] {
        return this.configuration.series.map(d => d.guid);
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, this.configuration.series, this.configuration,
            this.configuration.aggregation,
            false, false, false, false, false, ReadType.AggregatedValue, false,
            this.configuration.options.variableTypeGuid,
            this.configuration.options.unitGuid);
    }

    private getSeriesListAsync(): angular.IPromise<IBindable[]> {
        const result = this.configuration.series.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                relativePath: d.relativePath,
                isBoundToGroup: d.isBoundToGroup
            };
        });
        return this._$q.when(result);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = false;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = this.configuration.aggregation;
                const widgetValuesReadConfiguration = this.createConfiguration(data, aggregation, hasQuality,
                    hasMissingRanges, hasContext,
                    hasTendency, hasTarget, ReadType.AggregatedValue,
                    this.configuration.options.variableTypeGuid,
                    this.configuration.options.unitGuid);

                return widgetValuesReadConfiguration;
            });
    }
}